import { contentItems } from "@/lib/data/items";

export const tags = (() => {
  const counts = {};
  for (const item of contentItems) {
    for (const t of item.tags) counts[t] = (counts[t] || 0) + 1;
  }
  return Object.entries(counts)
    .map(([name, count], i) => ({ id: `tag-${i + 1}`, name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);
})();
